import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { DatosActa } from '../model/DatosActa.model';
import { DatosEncuestaActa } from '../model/DatosEncuestaActa.model';
import { AgendarTutoria } from '../model/Tutor.model';
import { TutorDisponibilidad } from '../model/TutorDisponibilidad';
import { StorageService } from './storage.service';


const getMyTutor = 'tutoria/getMyTutor/';
const getTutoriaJardin = 'tutoria/getTutoriaJardin/';
const getActaData = 'tutoria/getActaData/';
const finalizarActaJardin = 'tutoria/finalizarActaJardin/';
const agendarTutoriaURL = 'tutoria/agendarTutoria';
const crearActaTutor = 'tutoria/crearActaTutor';
const getTutorDisponibilidad = 'tutoria/getTutorDisponibilidad/';






const httpOptions = {
  headers: new HttpHeaders({
    'Content-Type':  'application/json',
    'Authorization': 'Basic ' + btoa('croamora:cristianroa.123')
  })
};  
const httpOptionsFile = {

  headers: new HttpHeaders({    
    'Authorization': 'Basic ' + btoa('croamora:cristianroa.123')
  })
}; 
@Injectable({
  providedIn: 'root'
})
export class TutoriaService {
 
  

  constructor(private http:HttpClient,private storageService: StorageService) { }

 
  API_POST_getTutoriasByIdUsuario(idUsuario: number) {
    return this.http.post(environment.apiEndpoint + getTutoriaJardin + idUsuario , null, httpOptions).pipe(
      catchError(this.handleError)
    );
  }

  API_POST_getActaData(idJardinPeriodoTutoria: number) {
    return this.http.post(environment.apiEndpoint + getActaData + idJardinPeriodoTutoria , null, httpOptions).pipe(
      catchError(this.handleError)
    );
  }

  API_POST_finalizarActaJardin(datosEncuestaActa: DatosEncuestaActa) {
    return this.http.post(environment.apiEndpoint + finalizarActaJardin , datosEncuestaActa, httpOptions).pipe(
      catchError(this.handleError)
    );
  }

  API_POST_getMyTutor(idUsuario: number) {
    return this.http.post(environment.apiEndpoint + getMyTutor + idUsuario , null, httpOptions).pipe(
      catchError(this.handleError)
    );
  }


  API_POST_agendarTutoria(agendarTutoria: AgendarTutoria) {
    return this.http.post(environment.apiEndpoint + agendarTutoriaURL  , agendarTutoria, httpOptions).pipe(
      catchError(this.handleError)
    );
  }

  API_POST_crearActaTutor(datosActa: DatosActa) {
    return this.http.post(environment.apiEndpoint + crearActaTutor  , datosActa, httpOptions).pipe(
      catchError(this.handleError)
    );
  }

  API_POST_getTutorDisponibilidad(idPersonaPeriodo: number,idJardinPeriodoTutoria: number) {
    return this.http.post(environment.apiEndpoint + getTutorDisponibilidad + idPersonaPeriodo + "/" + idJardinPeriodoTutoria , null, httpOptions).pipe(
      catchError(this.handleError)
    );
  }




  handleError(error) {    
    let errorMessage = '';
    errorMessage = `Error Code: ${error.status}\nMessage: ${error.error.message}`;
    return throwError(errorMessage);
  }

}
